import React, { useState, useEffect, useRef } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import Switch from '@mui/material/Switch';
import { Form } from 'react-bootstrap';

import LayoutContext from '../../../../../store/Layout/contexts';

import { config } from '../../../../../config/index';

import { GET, PUT, newFetch } from '../../../../../helpers/fetch';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../../components/SweetAlert';
import ManageDepartments from './ManageDepartments';

const { API_URL } = config;

const EditClient = ({ history, match: { params } }) => {
  const client_id = params.client_id;
  const token = localStorage.getItem('token');

  const [client, setClient] = useState({});
  const [name, setName] = useState('');
  const [managerFirstName, setManagerFirstName] = useState('');
  const [managerLastName, setManagerLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [smartScheduler, setSmartScheduler] = useState(false);
  const [event, setEvent] = useState(false);
  const [communication, setCommunication] = useState(false);
  const [leaveCredits, setLeaveCredits] = useState(false);
  const [claims, setClaims] = useState(false);
  const [edoc, setEdoc] = useState(false);
  const [startDay, setStartDay] = useState(0);
  const [Admins, setAdmins] = useState([]);
  const [oldAdmin, setOldAdmin] = useState([]);
  const [newAdmin, setNewAdmin] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState(0);
  const [validated, setValidated] = useState(false);
  const mountedRef = useRef(true);
  const departmentManagerRef = useRef(null);

  const fetchClient = async () => {
    const url = `${API_URL}/client/${client_id}`;

    if (token) {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();
        let clientData = data.data;
        if (mountedRef.current) {
          setClient(clientData);
          setName(clientData.name);
          setManagerFirstName(clientData.manager_first_name);
          setManagerLastName(clientData.manager_last_name);
          setEmail(clientData.email);
          setPhoneNo(clientData.phone_no);
          setSmartScheduler(clientData.enable_smart_scheduler);
          setEvent(clientData.enable_event);
          setCommunication(clientData.enable_communication);
          setLeaveCredits(clientData.enable_leave_credits);
          setClaims(clientData.enable_claims);
          setStartDay(clientData.start_day);
          setOldEscalationContacts(clientData.contacts);
          setOldAdmin(clientData.admin_clients.map((admins) => admins.admin));
          setEdoc(clientData.enable_edocs);
        }
      } else {
        console.log(response.message);
      }
    } else {
      console.log('Token is missing');
    }
  };
  const fetchAdmins = async () => {
    const url = `${API_URL}/admin/admins`;
    if (token) {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();
        let adminData = data.data;
        mountedRef.current && setAdmins(adminData);
      } else {
        console.log(response.message);
      }
    } else {
      console.log('Token is missing');
    }
  };

  const nameHandler = (e) => setName(e.target.value);
  const managerFirstNameHandler = (e) => setManagerFirstName(e.target.value);
  const managerLastNameHandler = (e) => setManagerLastName(e.target.value);
  const emailHandler = (e) => setEmail(e.target.value);
  const phoneNoHandler = (e) => setPhoneNo(e.target.value);
  const smartSchedulerHandler = (e) => setSmartScheduler(e.target.checked);
  const startDayHandler = (e) => setStartDay(e.target.value);

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?'
      )
    ) {
      setName(client.name);
      setManagerFirstName(client.manager_first_name);
      setManagerLastName(client.manager_last_name);
      setEmail(client.email);
      setPhoneNo(client.phone_no);
      setSmartScheduler(client.enable_smart_scheduler);
      setEvent(client.enable_event);
      setCommunication(client.enable_communication);
      setLeaveCredits(client.enable_leave_credits);
      setClaims(client.enable_claims);
      setStartDay(client.start_day);
      setEdoc(client.enable_edocs);
      departmentManagerRef.current?.discardChanges();
    }
  };

  const [SEVs, setSEVs] = useState([]);
  const [oldEscalationContacts, setOldEscalationContacts] = useState([]);
  const [newEscalationContacts, setNewEscalationContacts] = useState([]);

  const updateOldContactFirstNameHandler = (i, e) => {
    let clone = [...oldEscalationContacts];
    clone[i].first_name = e.target.value;
    setOldEscalationContacts(clone);
  };

  const updateOldContactLastNameHandler = (i, e) => {
    let clone = [...oldEscalationContacts];
    clone[i].last_name = e.target.value;
    setOldEscalationContacts(clone);
  };

  const updateOldContactEmailHandler = (i, e) => {
    let clone = [...oldEscalationContacts];
    clone[i].email = e.target.value;
    setOldEscalationContacts(clone);
  };

  const updateOldContactSEVHandler = (i, e) => {
    let clone = [...oldEscalationContacts];
    clone[i].sev_id = e.target.value;
    setOldEscalationContacts(clone);
  };

  const updateNewContactFirstNameHandler = (i, e) => {
    let clone = [...newEscalationContacts];
    clone[i].first_name = e.target.value;
    setNewEscalationContacts(clone);
  };

  const updateNewContactLastNameHandler = (i, e) => {
    let clone = [...newEscalationContacts];
    clone[i].last_name = e.target.value;
    setNewEscalationContacts(clone);
  };

  const updateNewContactEmailHandler = (i, e) => {
    let clone = [...newEscalationContacts];
    clone[i].email = e.target.value;
    setNewEscalationContacts(clone);
  };

  const updateNewContactSEVHandler = (i, e) => {
    let clone = [...newEscalationContacts];
    clone[i].sev_id = e.target.value;
    setNewEscalationContacts(clone);
  };

  const addContacts = () =>
    setNewEscalationContacts([
      ...newEscalationContacts,
      {
        first_name: '',
        last_name: '',
        email: '',
        sev_id: 1,
      },
    ]);

  const removeContact = (index) =>
    setNewEscalationContacts(
      [...newEscalationContacts].filter((contacts, i) => i !== index)
    );

  const removeOldAdmin = (id) =>
    setOldAdmin([...oldAdmin].filter((admin) => id !== admin.id));
  const removeAdmin = (index, id) =>
    setNewAdmin([...newAdmin].filter((admin, i) => i !== index));
  const addAdmin = () => {
    setNewAdmin([...newAdmin, Admins[0].id]);
  };

  const updateNewAdmin = (i, e) => {
    let clone = [...newAdmin];

    clone[i] = e.target.value;

    setSelectedAdmin(e.target.value);
    setNewAdmin(clone);
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      await submitHandler(event);
    }

    setValidated(true);
  };

  useEffect(() => {
    fetchClient();
    fetchAdmins();

    return () => (mountedRef.current = false);
  }, []);

  const submitHandler = async (e) => {
    e.preventDefault();
    let submitAdmin = [];
    let submitAdminTracker = [];
    const validAdmins = oldAdmin.filter(
      (e) => e && e.id && !isNaN(parseInt(e.id))
    );

    if (validAdmins.length === 0) {
      console.warn('No valid admin data found. Skipping submission.');
    } else {
      validAdmins.forEach((e) => {
        submitAdmin.push({
          client_id: parseInt(client_id),
          admin_id: parseInt(e.id),
        });
        submitAdminTracker.push(parseInt(e.id));
      });
    }

    newAdmin.map((e) => {
      if (submitAdminTracker.indexOf(parseInt(e)) === -1) {
        submitAdmin.push({
          client_id: parseInt(client_id),
          admin_id: parseInt(e),
        });
        submitAdminTracker.push(parseInt(e));
      }
    });

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to update this client details?'
      )
    ) {
      if (name && email) {
        const departmentsSaved =
          await departmentManagerRef.current?.saveDepartments();
        if (departmentsSaved === false) return;

        const contacts = [
          ...[...oldEscalationContacts].map((contact) => ({
            first_name: contact.first_name,
            last_name: contact.last_name,
            email: contact.email,
            sev_id: contact.sev_id,
          })),
          ...newEscalationContacts,
        ];

        const data = {
          name,
          manager_first_name: managerFirstName,
          manager_last_name: managerLastName,
          phone_no: phoneNo,
          enable_smart_scheduler: smartScheduler,
          enable_event: event,
          enable_communication: communication,
          enable_leave_credits: leaveCredits,
          enable_claims: claims,
          enable_edocs: edoc,
          start_day: startDay,
          contacts: contacts,
          client_admins: submitAdmin,
        };

        const api_path = `/client/${client_id}`;
        const response = await newFetch(PUT, api_path, data);
        if (response.success) {
          ToastUtil.success(response.message);
          history.push(`/clients/client/${client_id}`);
        }
      } else {
        ToastUtil.error('Please input all required fields!');
      }
    }
  };

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to="/clients"
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div style={{ color: '#0d6efd' }}>
                <i className="fas fa-chevron-left pe-2"></i>Back to Client
                Management
              </div>
            </NavLink>
            <div className="pt-4">
              <h5>Edit Client</h5>
            </div>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Client Information</strong>
                <p className="pt-2">Manage client's information</p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <div className="row">
                  <div className="col-sm-12">
                    <strong>Client Name*</strong>
                    <input
                      type="text"
                      required
                      className="form-control mt-3"
                      value={name}
                      onChange={(e) => nameHandler(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter client name.
                    </Form.Control.Feedback>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Client Contact</strong>
                <p className="pt-2">Manage client contact information</p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <div className="row">
                  <div className="col-sm-6">
                    <strong>First Name</strong>
                    <input
                      type="text"
                      className="form-control mt-3"
                      value={managerFirstName}
                      onChange={(e) => managerFirstNameHandler(e)}
                    />
                  </div>
                  <div className="col-sm-6">
                    <strong>Last Name</strong>
                    <input
                      type="text"
                      className="form-control mt-3"
                      value={managerLastName}
                      onChange={(e) => managerLastNameHandler(e)}
                    />
                  </div>
                </div>
                <div className="row pt-3">
                  <div className="col-sm-12">
                    <strong>Email*</strong>
                    <input
                      type="email"
                      disabled
                      className="form-control mt-3"
                      value={email}
                    />
                    <small className="form-text text-muted mt-3">
                      Log in credentials and instructions will be sent to this
                      email once the client is added.
                    </small>
                  </div>
                </div>
                <div className="row pt-3">
                  <div className="col-sm-12">
                    <strong>Phone No</strong>
                    <input
                      type="text"
                      className="form-control mt-3"
                      value={phoneNo}
                      onChange={(e) => phoneNoHandler(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Settings</strong>
                <p className="pt-2">Manage settings</p>
                <p className="pt-2 text-danger">
                  Please be informed that changing the access for a client will
                  force logout the client and their employees (they will have
                  to relogin).
                </p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Smart Scheduler</strong>
                    <Switch
                      checked={smartScheduler || false}
                      onChange={(e) => smartSchedulerHandler(e)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Claims</strong>
                    <Switch
                      checked={claims}
                      onChange={({ target: { checked } }) => setClaims(checked)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Leaves</strong>
                    <Switch
                      checked={leaveCredits}
                      onChange={({ target: { checked } }) =>
                        setLeaveCredits(checked)
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Communication</strong>
                    <Switch
                      checked={communication}
                      onChange={({ target: { checked } }) =>
                        setCommunication(checked)
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Event</strong>
                    <Switch
                      checked={event}
                      onChange={({ target: { checked } }) => setEvent(checked)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Edocs</strong>
                    <Switch
                      checked={edoc}
                      onChange={({ target: { checked } }) => setEdoc(checked)}
                    />
                  </div>
                </div>
                <div className="row pt-3">
                  <div className="col-sm-4">
                    <strong>Start day of the week:</strong>
                    <select
                      name=""
                      id=""
                      className="form-select mt-3"
                      value={startDay}
                      onChange={(e) => startDayHandler(e)}
                    >
                      <option value="0">Sun-Mon</option>
                      <option value="1">Mon-Sun</option>
                      <option value="2">Sat-Fri</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <ManageDepartments ref={departmentManagerRef} clientID={client_id} />

            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
                marginBottom: '6rem',
                display: 'none',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Escalation Contacts</strong>
                <p className="pt-2">Manage escalation contacts</p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                {oldEscalationContacts.length > 0 &&
                  oldEscalationContacts.map((contact, index) => (
                    <div key={index} className="pb-3">
                      <div className="d-flex justify-content-between">
                        <strong>Contact</strong>
                      </div>
                      <div
                        className="border rounded mt-3"
                        style={{ padding: '2.25rem' }}
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <strong>First Name</strong>
                            <input
                              type="text"
                              className="form-control mt-3"
                              value={contact.first_name}
                              onChange={(e) =>
                                updateOldContactFirstNameHandler(index, e)
                              }
                            />
                          </div>
                          <div className="col-sm-6">
                            <strong>Last Name</strong>
                            <input
                              type="text"
                              className="form-control mt-3"
                              value={contact.last_name}
                              onChange={(e) =>
                                updateOldContactLastNameHandler(index, e)
                              }
                            />
                          </div>
                        </div>
                        <div className="row pt-3">
                          <div className="col-sm-8">
                            <strong>Email</strong>
                            <input
                              type="email"
                              className="form-control mt-3"
                              value={contact.email}
                              onChange={(e) =>
                                updateOldContactEmailHandler(index, e)
                              }
                            />
                          </div>
                          <div className="col-sm-4">
                            <strong>SEV Level</strong>
                            <select
                              className="form-select mt-3"
                              value={contact.sev_id}
                              onChange={(e) =>
                                updateOldContactSEVHandler(index, e)
                              }
                            >
                              {SEVs &&
                                SEVs.length > 0 &&
                                SEVs.map((sev) => (
                                  <option key={sev.id} value={sev.id}>
                                    {sev.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                {newEscalationContacts.map((contact, index) => (
                  <div key={index} className="pb-3">
                    <div className="d-flex justify-content-between">
                      <strong>Contact</strong>
                      <h6
                        style={{ cursor: 'pointer' }}
                        className="text-danger"
                        onClick={() => removeContact(index)}
                      >
                        <i className="fas fa-trash"></i>&nbsp;&nbsp;&nbsp;Remove
                      </h6>
                    </div>
                    <div
                      className="border rounded mt-3"
                      style={{ padding: '2.25rem' }}
                    >
                      <div className="row">
                        <div className="col-sm-6">
                          <strong>First Name</strong>
                          <input
                            type="text"
                            className="form-control mt-3"
                            value={contact.first_name}
                            onChange={(e) =>
                              updateNewContactFirstNameHandler(index, e)
                            }
                          />
                        </div>
                        <div className="col-sm-6">
                          <strong>Last Name</strong>
                          <input
                            type="text"
                            className="form-control mt-3"
                            value={contact.last_name}
                            onChange={(e) =>
                              updateNewContactLastNameHandler(index, e)
                            }
                          />
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-sm-8">
                          <strong>Email</strong>
                          <input
                            type="text"
                            className="form-control mt-3"
                            value={contact.email}
                            onChange={(e) =>
                              updateNewContactEmailHandler(index, e)
                            }
                          />
                        </div>
                        <div className="col-sm-4">
                          <strong>SEV Level</strong>
                          <select
                            className="form-select mt-3"
                            value={contact.sev_id}
                            onChange={(e) =>
                              updateNewContactSEVHandler(index, e)
                            }
                          >
                            {SEVs &&
                              SEVs.length > 0 &&
                              SEVs.map((sev) => (
                                <option key={sev.id} value={sev.id}>
                                  {sev.name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div
                  onClick={() => addContacts()}
                  className="border rounded mt-3"
                  style={{
                    paddingLeft: '2.25rem',
                    paddingRight: '2.25rem',
                    paddingTop: '1.5rem',
                    paddingBottom: '1.5rem',
                    cursor: 'pointer',
                  }}
                >
                  <i className="fas fa-plus"></i>&nbsp;&nbsp;&nbsp;
                  <strong>Add Another Contact</strong>
                </div>
              </div>
            </div>

            <div
              style={{
                position: 'fixed',
                bottom: 0,
                width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                height: '4.5rem',
                paddingRight: '3rem',
              }}
              className="border-top bg-white d-flex align-items-center justify-content-end"
            >
              <button
                type="button"
                onClick={discardHandler}
                className="btn btn-outline-brand adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Discard
              </button>
              <button
                type="submit"
                className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Save changes
              </button>
            </div>
          </Form>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default withRouter(EditClient);
